// Easter egg helper: "pet the dog". Clicking the night-walk dog or the
// treat-catching dog floats a few hearts up from the click point and makes the
// dog do a happy hop. Styles live in src/css/easter-eggs.css.

const HEART_COUNT = 5;
const HEARTS_LIFETIME_MS = 1800; // longest heart delay + animation, with margin

const randomBetween = (min: number, max: number) => min + Math.random() * (max - min);

/**
 * Hearts are rendered in their own fixed layer on <body> so they aren't clipped
 * by the dogs' containers (the night-walk strip is only 22px tall).
 */
export const spawnHearts = (x: number, y: number) => {
  const layer = document.createElement('div');
  layer.className = 'pet-hearts';
  layer.setAttribute('aria-hidden', 'true');
  layer.style.left = `${x}px`;
  layer.style.top = `${y}px`;

  for (let i = 0; i < HEART_COUNT; i++) {
    const heart = document.createElement('span');
    heart.className = 'pet-heart';
    heart.textContent = '♥';
    heart.style.setProperty('--heart-dx', `${randomBetween(-28, 28).toFixed(1)}px`);
    heart.style.setProperty('--heart-rise', `${randomBetween(55, 85).toFixed(1)}px`);
    heart.style.setProperty('--heart-rot', `${randomBetween(-25, 25).toFixed(1)}deg`);
    heart.style.setProperty('--heart-size', `${randomBetween(13, 21).toFixed(1)}px`);
    heart.style.animationDelay = `${(i * 90 + randomBetween(0, 60)).toFixed(0)}ms`;
    layer.appendChild(heart);
  }

  document.body.appendChild(layer);
  window.setTimeout(() => layer.remove(), HEARTS_LIFETIME_MS);
};

/** Restart a one-shot CSS animation class, even if it's already applied. */
export const replayAnimationClass = (element: Element | null, className: string) => {
  if (!element) return;
  element.classList.remove(className);
  // Force a reflow so re-adding the class restarts the animation.
  element.getBoundingClientRect();
  element.classList.add(className);
};

export const petDog = (event: { clientX: number; clientY: number }, dog: Element | null) => {
  spawnHearts(event.clientX, event.clientY);
  replayAnimationClass(dog, 'pet-hop');
};
